import type { ErrorResponse } from 'react-router';
import type { PageWithComponentData } from '@/lib/util/pageLoader.server';

/** Page Designer page rendered below the 404 message. */
export const NOT_FOUND_PAGE_ID = 'not-found';

/** JSON body of the 404 response thrown by `notFoundResponse`. */
export type NotFoundErrorData = {
    notFoundPage: PageWithComponentData | null;
};

/**
 * Reads the Page Designer page attached by `notFoundResponse`. Plain 404 Responses (thrown
 * elsewhere or by React Router itself) carry no page, so the 404 renders without the region.
 */
export function getNotFoundPage(error: ErrorResponse): PageWithComponentData | null {
    const data: unknown = error.data;
    if (data && typeof data === 'object' && 'notFoundPage' in data) {
        return (data as NotFoundErrorData).notFoundPage ?? null;
    }
    return null;
}
